export interface BrandInfo {
    name: string;
    domain: string;
    category?: string;
}

const brandMap: { [key: string]: BrandInfo } = {
    // Streaming & Entertainment
    'netflix': { name: 'Netflix', domain: 'netflix.com', category: 'Lazer' },
    'spotify': { name: 'Spotify', domain: 'spotify.com', category: 'Lazer' },
    'disney': { name: 'Disney+', domain: 'disneyplus.com', category: 'Lazer' },
    'disney+': { name: 'Disney+', domain: 'disneyplus.com', category: 'Lazer' },
    'hbo': { name: 'HBO Max', domain: 'hbomax.com', category: 'Lazer' },
    'amazon prime': { name: 'Amazon Prime', domain: 'primevideo.com', category: 'Lazer' },
    'youtube': { name: 'YouTube', domain: 'youtube.com', category: 'Lazer' },
    'apple tv': { name: 'Apple TV', domain: 'apple.com', category: 'Lazer' },
    'cinema': { name: 'Cinema', domain: 'nos.pt', category: 'Lazer' },
    'nos': { name: 'NOS', domain: 'nos.pt', category: 'Internet' },
    'meo': { name: 'MEO', domain: 'meo.pt', category: 'Internet' },
    'vodafone': { name: 'Vodafone', domain: 'vodafone.pt', category: 'Internet' },
    'nowo': { name: 'NOWO', domain: 'nowo.pt', category: 'Internet' },

    // Supermarkets & Shopping (Portugal)
    'continente': { name: 'Continente', domain: 'continente.pt', category: 'Supermercado' },
    'pingo doce': { name: 'Pingo Doce', domain: 'pingodoce.pt', category: 'Supermercado' },
    'auchan': { name: 'Auchan', domain: 'auchan.pt', category: 'Supermercado' },
    'lidl': { name: 'Lidl', domain: 'lidl.pt', category: 'Supermercado' },
    'aldi': { name: 'ALDI', domain: 'aldi.pt', category: 'Supermercado' },
    'intermarche': { name: 'Intermarché', domain: 'intermarche.pt', category: 'Supermercado' },
    'el corte ingles': { name: 'El Corte Inglés', domain: 'elcorteingles.pt', category: 'Supermercado' },
    'mercadona': { name: 'Mercadona', domain: 'mercadona.pt', category: 'Supermercado' },
    'fnac': { name: 'FNAC', domain: 'fnac.pt', category: 'Compras' },
    'worten': { name: 'Worten', domain: 'worten.pt', category: 'Compras' },
    'radio popular': { name: 'Rádio Popular', domain: 'radiopopular.pt', category: 'Compras' },
    'ikea': { name: 'IKEA', domain: 'ikea.com', category: 'Casa' },
    'leroy merlin': { name: 'Leroy Merlin', domain: 'leroymerlin.pt', category: 'Casa' },
    'decathlon': { name: 'Decathlon', domain: 'decathlon.pt', category: 'Lazer' },
    'zara': { name: 'Zara', domain: 'zara.com', category: 'Compras' },
    'h&m': { name: 'H&M', domain: 'hm.com', category: 'Compras' },
    'primark': { name: 'Primark', domain: 'primark.com', category: 'Compras' },
    'nike': { name: 'Nike', domain: 'nike.com', category: 'Compras' },
    'adidas': { name: 'Adidas', domain: 'adidas.com', category: 'Compras' },
    'amazon': { name: 'Amazon', domain: 'amazon.com', category: 'Compras' },
    'apple': { name: 'Apple', domain: 'apple.com', category: 'Compras' },

    // Transport & Fuel
    'uber': { name: 'Uber', domain: 'uber.com', category: 'Transporte' },
    'bolt': { name: 'Bolt', domain: 'bolt.eu', category: 'Transporte' },
    'cabify': { name: 'Cabify', domain: 'cabify.com', category: 'Transporte' },
    'lime': { name: 'Lime', domain: 'li.me', category: 'Transporte' },
    'bird': { name: 'Bird', domain: 'bird.co', category: 'Transporte' },
    'cp': { name: 'CP', domain: 'cp.pt', category: 'Transporte' },
    'comboios de portugal': { name: 'CP', domain: 'cp.pt', category: 'Transporte' },
    'carris': { name: 'Carris', domain: 'carris.pt', category: 'Transporte' },
    'metro lisboa': { name: 'Metro', domain: 'metrolisboa.pt', category: 'Transporte' },
    'via verde': { name: 'Via Verde', domain: 'viaverde.pt', category: 'Transporte' },
    'galp': { name: 'Galp', domain: 'galp.com', category: 'Transporte' },
    'bp': { name: 'BP', domain: 'bp.com', category: 'Transporte' },
    'repsol': { name: 'Repsol', domain: 'repsol.com', category: 'Transporte' },
    'prio': { name: 'Prio', domain: 'prio.pt', category: 'Transporte' },
    'cepsa': { name: 'Cepsa', domain: 'cepsa.pt', category: 'Transporte' },
    'shell': { name: 'Shell', domain: 'shell.com', category: 'Transporte' },
    'tesla': { name: 'Tesla', domain: 'tesla.com', category: 'Transporte' },

    // Food & Dining
    'uber eats': { name: 'Uber Eats', domain: 'ubereats.com', category: 'Alimentação' },
    'ubereats': { name: 'Uber Eats', domain: 'ubereats.com', category: 'Alimentação' },
    'glovo': { name: 'Glovo', domain: 'glovoapp.com', category: 'Alimentação' },
    'mcdonalds': { name: 'McDonald\'s', domain: 'mcdonalds.com', category: 'Alimentação' },
    'mcdonald\'s': { name: 'McDonald\'s', domain: 'mcdonalds.com', category: 'Alimentação' },
    'mc donalds': { name: 'McDonald\'s', domain: 'mcdonalds.com', category: 'Alimentação' },
    'burger king': { name: 'Burger King', domain: 'burgerking.pt', category: 'Alimentação' },
    'kfc': { name: 'KFC', domain: 'kfc.pt', category: 'Alimentação' },
    'pizza hut': { name: 'Pizza Hut', domain: 'pizzahut.pt', category: 'Alimentação' },
    'dominos': { name: 'Domino\'s', domain: 'dominos.pt', category: 'Alimentação' },
    'telepizza': { name: 'Telepizza', domain: 'telepizza.pt', category: 'Alimentação' },
    'starbucks': { name: 'Starbucks', domain: 'starbucks.com', category: 'Café' },
    'nespresso': { name: 'Nespresso', domain: 'nespresso.com', category: 'Café' },
    'delta': { name: 'Delta', domain: 'delta-cafes.com', category: 'Café' },

    // Services & Utilities
    'edp': { name: 'EDP', domain: 'edp.pt', category: 'Eletricidade' },
    'endesa': { name: 'Endesa', domain: 'endesa.pt', category: 'Eletricidade' },
    'iberdrola': { name: 'Iberdrola', domain: 'iberdrola.pt', category: 'Eletricidade' },
    'goldenergy': { name: 'Goldenergy', domain: 'goldenergy.pt', category: 'Eletricidade' },
    'epal': { name: 'EPAL', domain: 'epal.pt', category: 'Água' },
    'aguas': { name: 'Águas', domain: 'aguasdeportugal.pt', category: 'Água' },
    'fitness hut': { name: 'Fitness Hut', domain: 'fitnesshut.pt', category: 'Ginásio' },
    'solinca': { name: 'Solinca', domain: 'solinca.pt', category: 'Ginásio' },

    // Tech & Software
    'google': { name: 'Google', domain: 'google.com', category: 'Serviços' },
    'microsoft': { name: 'Microsoft', domain: 'microsoft.com', category: 'Serviços' },
    'adobe': { name: 'Adobe', domain: 'adobe.com', category: 'Serviços' },
    'github': { name: 'GitHub', domain: 'github.com', category: 'Serviços' },
    'gitlab': { name: 'GitLab', domain: 'gitlab.com', category: 'Serviços' },
    'aws': { name: 'AWS', domain: 'aws.amazon.com', category: 'Serviços' },
    'azure': { name: 'Azure', domain: 'azure.microsoft.com', category: 'Serviços' },
    'jetbrains': { name: 'JetBrains', domain: 'jetbrains.com', category: 'Serviços' },
    'cursor': { name: 'Cursor', domain: 'cursor.sh', category: 'Serviços' },
    'openai': { name: 'OpenAI', domain: 'openai.com', category: 'Serviços' },
    'chatgpt': { name: 'ChatGPT', domain: 'openai.com', category: 'Serviços' },
    'anthropic': { name: 'Anthropic', domain: 'anthropic.com', category: 'Serviços' },

    // Banking (Portugal)
    'cgd': { name: 'CGD', domain: 'cgd.pt', category: 'Bancos' },
    'caixa geral': { name: 'CGD', domain: 'cgd.pt', category: 'Bancos' },
    'millennium': { name: 'Millennium BCP', domain: 'millenniumbcp.pt', category: 'Bancos' },
    'bcp': { name: 'Millennium BCP', domain: 'millenniumbcp.pt', category: 'Bancos' },
    'novo banco': { name: 'Novo Banco', domain: 'novobanco.pt', category: 'Bancos' },
    'santander': { name: 'Santander', domain: 'santander.pt', category: 'Bancos' },
    'bpi': { name: 'BPI', domain: 'bancobpi.pt', category: 'Bancos' },
    'activobank': { name: 'ActivoBank', domain: 'activobank.pt', category: 'Bancos' },
    'revolut': { name: 'Revolut', domain: 'revolut.com', category: 'Bancos' },
    'moey': { name: 'Moey!', domain: 'moey.pt', category: 'Bancos' },
    'mbway': { name: 'MB WAY', domain: 'mbway.pt', category: 'Serviços' },
    'paypal': { name: 'PayPal', domain: 'paypal.com', category: 'Serviços' }
};

export const identifyBrand = (description: string): BrandInfo | null => {
    if (!description) return null;

    const lowerDesc = description.toLowerCase().trim();

    // Sort keys by length descending so longer brands like 'uber eats' match before 'uber'
    const sortedKeys = Object.keys(brandMap).sort((a, b) => b.length - a.length);

    // Check for exact word matches or starts with for better accuracy
    const brandKey = sortedKeys.find(key => {
        // Escape special regex characters in the brand key
        const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        // Match exact word to avoid "Uber" matching "Uberlandia"
        // Using (^|\W|_) instead of \b to properly handle brands ending in special characters like '+' or '!'
        const regex = new RegExp(`(^|\\W|_)${escapedKey}($|\\W|_)`, 'i');
        return regex.test(lowerDesc);
    });

    return brandKey ? brandMap[brandKey] : null;
};

export const normalizeDescription = (description: string): string => {
    const brand = identifyBrand(description);
    if (brand) {
        return brand.name;
    }
    // Proper capitalization for non-brands (first letter uppercase)
    return description.trim().charAt(0).toUpperCase() + description.trim().slice(1).toLowerCase();
};

export const getLogoUrl = (domain: string): string => {
    return `https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://${domain}&size=128`;
};

export const getBrandLogo = (description: string): string | null => {
    const brand = identifyBrand(description);
    return brand ? getLogoUrl(brand.domain) : null;
};
